// ==== Request a Quote popup: product code (SKU), closure summary, quantity ====
function buildClosureSummaryForQuote(data, variantId) {
  if (!data || !variantId) return '';
  const parts = [];
  const ct = data.closureType && data.closureType[variantId];
  const cs = data.closureSize && data.closureSize[variantId];
  const cc = data.closureColour && data.closureColour[variantId];
  const dt = data.dipTubeLength && data.dipTubeLength[variantId];
  function nonempty(v) {
    return v != null && v !== '' && v !== 'null';
  }
  if (nonempty(ct)) parts.push('Closure Type: ' + ct);
  if (nonempty(cs)) parts.push('Size: ' + cs);
  if (nonempty(cc)) parts.push('Colour: ' + cc);
  if (nonempty(dt)) parts.push('Dip tube: ' + dt);
  return parts.join('; ');
}

function syncRequestQuotePopupFields() {
  const codeInput = document.getElementById('request-quote-product-code');
  const closureInput = document.getElementById('request-quote-closure');
  if (!codeInput || !closureInput) return;

  const mainForm = document.querySelector('form[data-type="add-to-cart-form"]');
  const variantInput = mainForm && mainForm.querySelector('input[name="id"]');
  const variantId = variantInput && variantInput.value;
  if (!variantId) {
    codeInput.value = '';
    closureInput.value = '';
    return;
  }

  let sku = '';
  let closure = '';
  const script = document.getElementById('variant-metafields-data');
  if (script && script.textContent) {
    try {
      const data = JSON.parse(script.textContent);
      if (data.sku && data.sku[variantId] != null) {
        sku = String(data.sku[variantId] || '').trim();
      }
      closure = buildClosureSummaryForQuote(data, variantId);
    } catch (e) {}
  }
  if (!sku) {
    const skuNode = document.querySelector('.f-product-single__blocks [data-product-sku]');
    if (skuNode) sku = skuNode.textContent.trim();
  }
  codeInput.value = sku ? 'SKU Code: ' + sku : '';
  closureInput.value = closure;
}

// ==== Product Page Popups ====
document.addEventListener('DOMContentLoaded', function() {
    // Check if URL contains contact_posted=true
    const urlParams = new URLSearchParams(window.location.search);
    const contactPosted = urlParams.get('contact_posted');
    
    if (contactPosted === 'true') {
      // Show the success message
      const successMessage = document.getElementById('contact-success-message');
      if (successMessage) {
        successMessage.classList.add('show');
        
        // Show the popup
        const popupWrapper = document.querySelector('.request-quote-popup');
        if (popupWrapper) {
          popupWrapper.style.display = 'block';
        }
        
        // Remove the URL parameter to prevent showing the message on page refresh
        const newUrl = window.location.pathname + window.location.hash;
        window.history.replaceState({}, document.title, newUrl);
        
        // Auto-close popup after 5 seconds
        setTimeout(function() {
          closePopup();
        }, 5000);
      }
    }
    
    // Close popup functionality
    const closeButton = document.querySelector('.product-popup__close');
    const overlay = document.querySelector('.product-popup-overlay');
    const popupWrapper = document.querySelector('.request-quote-popup');
    
    function closePopup() {
      if (popupWrapper) {
        popupWrapper.style.display = 'none';
      }
      if (overlay) {
        overlay.style.display = 'none';
      }
    }
    
    // Close when clicking the close button
    if (closeButton) {
      closeButton.addEventListener('click', closePopup);
    }
    

    
    // Show popup when clicking request quote button
    const requestQuoteBtn = document.querySelector('.request-quote-btn');
    if (requestQuoteBtn) {
      requestQuoteBtn.addEventListener('click', function(e) {
        e.preventDefault(); // Prevent the default link behavior
        
        // Show the popup and overlay
        if (popupWrapper) {
          popupWrapper.style.display = 'block';
        }
        if (overlay) {
          overlay.style.display = 'block';
        }
      });
    }
    
    function checkVariantSelection() {
      // Empty function for future use
    }
    
    // Initialise variant checking
    checkVariantSelection();

    syncRequestQuotePopupFields();
    document.addEventListener('variant:changed', function () {
      syncRequestQuotePopupFields();
    });
    if (window.FoxThemeEvents && typeof window.FoxThemeEvents.subscribe === 'function') {
      window.FoxThemeEvents.subscribe('variant-change', function () {
        syncRequestQuotePopupFields();
      });
    }
    
    // Handle lids popup buttons
    const lidsPopup = document.querySelector('.lids-popup');
    const lidsYesBtn = document.querySelector('.lids-popup__buttons .btn:first-child');
    const lidsNoBtn = document.querySelector('.lids-popup__buttons .btn:last-child');
    
    // Handle pallet popup buttons
    const palletPopup = document.querySelector('.pallet-popup');
    //console.log('Pallet popup found:', palletPopup);

    const palletYesBtn = document.querySelector('.pallet-yes-button');
    const palletNoBtn = document.querySelector('.pallet-no-button');   
    
    function closeLidsPopup() {
      if (lidsPopup) {
        lidsPopup.style.display = 'none';
      }
      if (overlay) {
        overlay.style.display = 'none';
      }
    }
    
    function closePalletPopup() {
      if (palletPopup) {
        palletPopup.style.display = 'none';
      }
      if (overlay) {
        overlay.style.display = 'none';
      }
    }
    
    // Function to handle lids popup close (used by both "No thanks" button and X button)
    function handleLidsPopupClose() {
      closeLidsPopup();
      unfittedConfirmed = true;
      
      setTimeout(function() {
        const submitButton = document.querySelector('.f-product-form__submit');
        if (submitButton) {
          submitButton.click();
        }
      }, 100);
    }
    
    if (lidsYesBtn) {
      lidsYesBtn.addEventListener('click', function() {
        closeLidsPopup();
      });
    }
    
    if (lidsNoBtn) {
      lidsNoBtn.addEventListener('click', handleLidsPopupClose);
    }
    
    // Handle X button click for lids popup (same as "No thanks" button)
    const lidsPopupCloseBtn = document.querySelector('.lids-popup__close');
    if (lidsPopupCloseBtn) {
      //console.log('Lids popup X button found and listener added');
      lidsPopupCloseBtn.addEventListener('click', handleLidsPopupClose);
    } else {
      console.log('Lids popup X button not found');
    }
    
    if (palletYesBtn) {
      palletYesBtn.addEventListener('click', function() {
        // Show the lids content instead of closing
        const lidsContent = document.querySelector('.pallet-popup .lids-popup__content');
        if (lidsContent) {
          lidsContent.style.display = 'block';
          console.log('Showing lids content');
        }
      });
    }
    
    // Handle .pallet-yes-button click to show .pallet-popup__content
    if (palletYesBtn) {
      palletYesBtn.addEventListener('click', function() {
        const palletPopupContent = document.querySelector('.pallet-popup__content');
        if (palletPopupContent) {
          palletPopupContent.style.display = 'block';
          console.log('Showing pallet popup content');
        } else {
          console.log('Pallet popup content not found');
        }
      });
    }
    
    // Handle .matching-closure-link clicks - add to cart and redirect
    const matchingClosureLinks = document.querySelectorAll('.matching-closure-link');
    //console.log('Found matching closure links (.matching-closure-link):', matchingClosureLinks.length);
  
    matchingClosureLinks.forEach(function(link, index) {
      
      link.addEventListener('click', function(e) {
        console.log('Matching closure link clicked!');
        e.preventDefault(); // Prevent default link behavior
        e.stopPropagation(); // Stop event bubbling
        
        // Show loading state on the clicked link itself
        const clickedLink = this;
        const originalLinkText = clickedLink.innerHTML;
        const loadingSvg = '<svg class="icon icon-spinner" aria-hidden="true" focusable="false" role="presentation" viewBox="0 0 20 20" style="width: 16px; height: 16px; animation: spin 1s linear infinite;"><path d="M7.229 1.173a9.25 9.25 0 1011.655 11.412 1.25 1.25 0 10-2.4-.698 6.75 6.75 0 11-8.508-8.329 1.25 1.25 0 10-.747 1.615z" fill="currentColor"/></svg>';
        
        clickedLink.innerHTML = loadingSvg;
        clickedLink.style.pointerEvents = 'none';
        
        // Add CSS animation if it doesn't exist
        if (!document.querySelector('#spinner-animation')) {
          const style = document.createElement('style');
          style.id = 'spinner-animation';
          style.textContent = `
            @keyframes spin {
              from { transform: rotate(0deg); }
              to { transform: rotate(360deg); }
            }
          `;
          document.head.appendChild(style);
        }
        
        const targetUrl = this.getAttribute('data-url'); // Store the URL to redirect to (closure product URL)
        
        console.log('Matching closure link clicked - Closure URL:', targetUrl);
        
        // Get the CURRENT PAGE'S selected variant ID (not the closure product)
        let variantId = null;
        
        // Method 1: Get from the product form input
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput && variantInput.value) {
            variantId = variantInput.value;
            console.log('Found current page variant ID from form input:', variantId);
          }
        }
        
        // Method 2: Get from variant picker if form input not found
        if (!variantId) {
          const variantPicker = document.querySelector('[data-variant-picker]');
          if (variantPicker) {
            const selectedVariantScript = variantPicker.querySelector('[data-selected-variant]');
            if (selectedVariantScript) {
              try {
                const selectedVariant = JSON.parse(selectedVariantScript.textContent);
                if (selectedVariant && selectedVariant.id) {
                  variantId = selectedVariant.id.toString();
                  console.log('Found current page variant ID from variant picker:', variantId);
                }
              } catch (e) {
                console.log('Error parsing variant data:', e);
              }
            }
          }
        }
        
        // Get max quantity from quantity selector (or use selected quantity as fallback)
        const quantityInput = document.querySelector('input[name="quantity"]');
        let quantity = 1;
        
        if (quantityInput) {
          // Try to get max quantity first
          const maxQuantity = quantityInput.getAttribute('max') || quantityInput.getAttribute('data-max');
          if (maxQuantity && maxQuantity !== 'null' && maxQuantity !== '') {
            quantity = parseInt(maxQuantity);
            console.log('Using max quantity from input:', quantity);
          } else {
            // If no max, use the current value
            quantity = parseInt(quantityInput.value) || 1;
            console.log('No max quantity found, using selected quantity:', quantity);
          }
        }
        
        console.log('Final quantity to add:', quantity);
        
        // Function to add item to cart
        function addToCartWithVariant(variantId, quantityParam, targetUrl, clickedLink, originalLinkText) {
          if (!variantId) {
            console.error('No variant ID provided');
            clickedLink.innerHTML = originalLinkText;
            clickedLink.style.pointerEvents = 'auto';
            // Redirect anyway
            window.location.href = targetUrl;
            return;
          }
          
          // Use the max quantity (or fallback to param/selected quantity)
          let quantity = quantityParam || 1;
          
          // Try to get max quantity from the input if available
          const quantityInput = document.querySelector('input[name="quantity"]');
          if (quantityInput) {
            const maxQuantityAttr = quantityInput.getAttribute('max') || quantityInput.getAttribute('data-max');
            if (maxQuantityAttr && maxQuantityAttr !== 'null' && maxQuantityAttr !== '' && maxQuantityAttr !== 'undefined') {
              const maxQuantity = parseInt(maxQuantityAttr);
              if (!isNaN(maxQuantity) && maxQuantity > 0) {
                quantity = maxQuantity;
                console.log('Using max quantity from input:', quantity);
              } else {
                console.log('Max quantity is invalid:', maxQuantityAttr, 'using param/selected quantity');
                if (!quantityParam) {
                  quantity = parseInt(quantityInput.value) || 1;
                }
              }
            } else {
              console.log('No max quantity attribute found, using param/selected quantity');
              if (!quantityParam) {
                quantity = parseInt(quantityInput.value) || 1;
              }
            }
          }
          
          // Validate variant ID and quantity
          const parsedVariantId = parseInt(variantId);
          if (isNaN(parsedVariantId) || parsedVariantId <= 0) {
            console.error('Invalid variant ID:', variantId);
            clickedLink.innerHTML = originalLinkText;
            clickedLink.style.pointerEvents = 'auto';
            // Redirect anyway
            window.location.href = targetUrl;
            return;
          }
          
          // Ensure quantity is valid (at least 1)
          const validQuantity = Math.max(1, parseInt(quantity) || 1);
          
          console.log('Adding to cart - Variant ID:', parsedVariantId, 'Quantity:', validQuantity);
          
          // Function to show cart drawer and redirect
          function showCartDrawerAndRedirect(errorMessage) {
            const cartDrawer = document.querySelector('cart-drawer');
            const drawer = document.querySelector('#Drawer-Cart');
            
            // Function to display error message in cart drawer
            function displayErrorInDrawer(message) {
              if (!message) return;
              
              const cartDrawerErrorContainer = document.querySelector('.f-cart-drawer__error-message-wrapper-container');
              if (cartDrawerErrorContainer) {
                // Create notification HTML matching the structure from product-form.js
                const notificationHTML = `
                  <div class="f-notification warning show">
                    <svg fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                    </svg>
                    <div class="ml-3">${message}</div>
                  </div>
                `;
                
                // Clear any existing notification and add new one
                cartDrawerErrorContainer.innerHTML = notificationHTML;
                
                // Auto-hide after 20 seconds
                setTimeout(() => {
                  const notification = cartDrawerErrorContainer.querySelector('.f-notification');
                  if (notification) {
                    notification.classList.add('hide');
                    setTimeout(() => {
                      cartDrawerErrorContainer.innerHTML = '';
                    }, 600); // Wait for transition
                  }
                }, 20000);
              }
            }
            
            if (cartDrawer && drawer) {
              // Get sections to render
              const sectionsToFetch = cartDrawer.getSectionsToRender ? cartDrawer.getSectionsToRender(true) : [];
              const sectionIds = sectionsToFetch.map(s => s.id);
              
              if (sectionIds.length > 0) {
                // Fetch cart state with sections
                const updateBody = JSON.stringify({
                  updates: {},
                  sections: sectionIds,
                  sections_url: window.location.pathname,
                });
                
                fetch('/cart/update.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                  },
                  body: updateBody
                })
                .then(res => res.json())
                .then(cartState => {
                  console.log('Cart state fetched:', cartState);
                  
                  // Render cart drawer contents (this will auto-open if openWhenAdded is true)
                  if (cartDrawer.renderContents && cartState.sections) {
                    cartDrawer.renderContents(cartState, true, true);
                  }
                  
                  // Display error message if provided
                  if (errorMessage) {
                    // Wait a moment for drawer to render, then show error
                    setTimeout(() => {
                      displayErrorInDrawer(errorMessage);
                    }, 100);
                  }
                  
                  // Ensure drawer is open
                  if (!drawer.isOpen() && drawer.openDrawer) {
                    drawer.openDrawer();
                  }
                  
                  // Redirect after a short delay to let user see the drawer
                  setTimeout(() => {
                    console.log('Redirecting to:', targetUrl);
                    window.location.href = targetUrl;
                  }, 2000);
                })
                .catch(err => {
                  console.error('Error fetching cart state:', err);
                  
                  // Display error message if provided
                  if (errorMessage) {
                    displayErrorInDrawer(errorMessage);
                  }
                  
                  // Trigger cart refresh event as fallback
                  document.dispatchEvent(new CustomEvent('cart:refresh', {
                    detail: { open: true }
                  }));
                  // Still redirect even if cart state fetch fails
                  setTimeout(() => {
                    console.log('Redirecting to:', targetUrl);
                    window.location.href = targetUrl;
                  }, 1500);
                });
              } else {
                // Display error message if provided
                if (errorMessage) {
                  displayErrorInDrawer(errorMessage);
                }
                
                // Fallback: trigger cart refresh event
                document.dispatchEvent(new CustomEvent('cart:refresh', {
                  detail: { open: true }
                }));
                setTimeout(() => {
                  window.location.href = targetUrl;
                }, 1500);
              }
            } else {
              // Fallback: redirect immediately if drawer not found
              console.log('Cart drawer not found, redirecting immediately');
              setTimeout(() => {
                window.location.href = targetUrl;
              }, 500);
            }
          }
          
          // Add item to cart using Shopify's AJAX API
          const formData = {
            'items': [{
              'id': parsedVariantId,
              'quantity': validQuantity
            }]
          };
          
          console.log('Sending cart request with data:', formData);
          
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(formData)
          })
          .then(response => {
            console.log('Cart response status:', response.status);
            console.log('Cart response headers:', response.headers);
            
            return response.json().then(data => {
              console.log('Cart response data:', data);
              
              // Check if Shopify returned an error message
              // Shopify returns errors with 'description' or 'message' properties
              // Success responses have 'items' array or 'item_count'
              if (response.status >= 400) {
                const errorMsg = data.description || data.message || `HTTP ${response.status} error`;
                console.error('Cart add error (HTTP):', errorMsg);
                console.error('Attempted to add variant:', parsedVariantId, 'with quantity:', validQuantity);
                throw new Error(errorMsg);
              }
              
              // Check for Shopify error messages in response body
              // Note: Successful responses can have 'description' field too, so check for items array
              if (data.description && (!data.items || (Array.isArray(data.items) && data.items.length === 0))) {
                const errorMsg = data.description || data.message || 'Unknown error';
                console.error('Cart add error (Shopify):', errorMsg);
                console.error('Attempted to add variant:', parsedVariantId, 'with quantity:', validQuantity);
                
                // If error and we used max quantity, try with selected quantity first, then 1
                if (validQuantity > 1) {
                  // First try with the selected quantity from the input
                  const quantityInput = document.querySelector('input[name="quantity"]');
                  const selectedQuantity = quantityInput ? parseInt(quantityInput.value) || 1 : 1;
                  
                  if (selectedQuantity > 0 && selectedQuantity < validQuantity) {
                    console.log('Retrying with selected quantity:', selectedQuantity, 'instead of max:', validQuantity);
                    const retryFormData = {
                      'items': [{
                        'id': parsedVariantId,
                        'quantity': selectedQuantity
                      }]
                    };
                    
                    return fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(retryFormData)
                    })
                    .then(retryResponse => {
                      console.log('Retry (selected qty) response status:', retryResponse.status);
                      return retryResponse.json().then(retryData => {
                        console.log('Retry (selected qty) response data:', retryData);
                        if (retryResponse.status >= 400 || (retryData.description && (!retryData.items || (Array.isArray(retryData.items) && retryData.items.length === 0)))) {
                          // If selected quantity also fails, try with 1
                          if (selectedQuantity > 1) {
                            console.log('Selected quantity also failed, retrying with quantity 1...');
                            return fetch('/cart/add.js', {
                              method: 'POST',
                              headers: {
                                'Content-Type': 'application/json',
                              },
                              body: JSON.stringify({
                                'items': [{
                                  'id': parsedVariantId,
                                  'quantity': 1
                                }]
                              })
                            })
                            .then(finalResponse => finalResponse.json().then(finalData => {
                              if (finalResponse.status >= 400 || (finalData.description && (!finalData.items || (Array.isArray(finalData.items) && finalData.items.length === 0)))) {
                                throw new Error(finalData.description || finalData.message || 'Unable to add item to cart');
                              }
                              return finalData;
                            }));
                          }
                          throw new Error(retryData.description || retryData.message || 'Unknown error');
                        }
                        return retryData;
                      });
                    });
                  } else {
                    // No selected quantity or it's the same, try with 1
                    console.log('Retrying with quantity 1 due to error...');
                    const retryFormData = {
                      'items': [{
                        'id': parsedVariantId,
                        'quantity': 1
                      }]
                    };
                    
                    return fetch('/cart/add.js', {
                      method: 'POST',
                      headers: {
                        'Content-Type': 'application/json',
                      },
                      body: JSON.stringify(retryFormData)
                    })
                    .then(retryResponse => {
                      console.log('Retry response status:', retryResponse.status);
                      return retryResponse.json().then(retryData => {
                        console.log('Retry response data:', retryData);
                        if (retryResponse.status >= 400 || (retryData.description && (!retryData.items || (Array.isArray(retryData.items) && retryData.items.length === 0)))) {
                          throw new Error(retryData.description || retryData.message || 'Unknown error');
                        }
                        return retryData;
                      });
                    });
                  }
                }
                
                throw new Error(errorMsg);
              }
              
              // Success - return the data
              return data;
            }).catch(err => {
              console.error('Error parsing cart response:', err);
              throw err;
            });
          })
          .then(data => {
            console.log('Item added to cart successfully:', data);
            // Show cart drawer and redirect
            showCartDrawerAndRedirect();
          })
          .catch(error => {
            console.error('Error adding item to cart:', error);
            console.error('Error details - Variant ID:', parsedVariantId, 'Quantity:', validQuantity);
            // Restore link state on error
            clickedLink.innerHTML = originalLinkText;
            clickedLink.style.pointerEvents = 'auto';
            // Get error message to display in drawer
            // Extract the actual Shopify error message if available
            let errorMessage = error.message || 'There was an error adding the item to your cart.';
            
            // If the error message contains Shopify-specific errors, use those
            if (errorMessage.includes('quantity') || errorMessage.includes('maximum') || errorMessage.includes('limit')) {
              // Keep the Shopify error message as-is
            } else if (errorMessage.includes('HTTP')) {
              // Generic HTTP error, try to make it more user-friendly
              errorMessage = 'Unable to add the requested quantity to your cart. Please try a smaller quantity.';
            }
            
            // Show cart drawer with error message and redirect
            console.log('Showing cart drawer with error message:', errorMessage);
            showCartDrawerAndRedirect(errorMessage);
          });
        }
        
        // Call the function if we have a variant ID from the current page
        if (variantId) {
          console.log('Adding current page product to cart - Variant ID:', variantId, 'Quantity:', quantity);
          addToCartWithVariant(variantId, quantity, targetUrl, clickedLink, originalLinkText);
        } else {
          // If we still don't have a variant ID, redirect anyway
          console.error('No variant ID found for current page product - redirecting anyway');
          clickedLink.innerHTML = originalLinkText;
          clickedLink.style.pointerEvents = 'auto';
          window.location.href = targetUrl;
        }
      });
    });
    
    // Function to handle pallet popup close (used by both "No thanks" button and X button)
    function handlePalletPopupClose() {
      console.log('Pallet popup close triggered');
      closePalletPopup();
      console.log('Pallet popup closed');
      unfittedConfirmed = true;
      console.log('unfittedConfirmed set to true');
      
      setTimeout(function() {
        const submitButton = document.querySelector('.f-product-form__submit');
        if (submitButton) {
          submitButton.click();
        } else {
          console.log('Submit button not found');
        }
      }, 100);
    }
    
    if (palletNoBtn) {
      //console.log('Pallet No button found and listener added');
      palletNoBtn.addEventListener('click', handlePalletPopupClose);
    } else {
      console.log('Pallet No button not found');
    }
    
    // Handle X button click for pallet popup
    const palletPopupCloseBtn = document.querySelector('.pallet-popup__close');
    if (palletPopupCloseBtn) {
      //console.log('Pallet popup X button found and listener added');
      palletPopupCloseBtn.addEventListener('click', handlePalletPopupClose);
    } else {
      console.log('Pallet popup X button not found');
    }
    

    
    let unfittedConfirmed = false;
    
    const productForm = document.querySelector('.f-product-form__submit');
    if (productForm) {
      productForm.addEventListener('click', function(e) {
        if (unfittedConfirmed) {
          console.log('unfittedConfirmed is true, allowing form submission');
          unfittedConfirmed = false;
          return true;
        }
        
        // Get the current selected variant
        const variantPicker = document.querySelector('[data-variant-picker]');
        if (variantPicker) {
          const selectedVariantScript = variantPicker.querySelector('[data-selected-variant]');
          if (selectedVariantScript) {
            try {
              const selectedVariant = JSON.parse(selectedVariantScript.textContent);
              if (selectedVariant && selectedVariant.title) {
                // Check if the variant title contains "pallet" or "unfitted" (case insensitive)
                const variantTitle = selectedVariant.title.toLowerCase();
                if (variantTitle.includes('pallet')) {
                  console.log('Pallet variant detected:', variantTitle);
                  e.preventDefault(); // Prevent form submission
                  
                  // Show the pallet popup and overlay
                  const palletPopup = document.querySelector('.pallet-popup');
                  const overlay = document.querySelector('.product-popup-overlay');
                  
                  console.log('Pallet popup element:', palletPopup);
                  console.log('Overlay element:', overlay);
                  
                  if (palletPopup) {
                    palletPopup.style.display = 'block';
                    console.log('Pallet popup shown');
                  } else {
                    console.log('Pallet popup not found');
                  }
                  if (overlay) {
                    overlay.style.display = 'block';
                    console.log('Overlay shown');
                  } else {
                    console.log('Overlay not found');
                  }
                  
                  return false;
                } else if (variantTitle.includes('unfitted')) {
                  e.preventDefault(); // Prevent form submission
                  
                  // Show the lids popup and overlay
                  const lidsPopup = document.querySelector('.lids-popup');
                  const overlay = document.querySelector('.product-popup-overlay');
                  
                  if (lidsPopup) {
                    lidsPopup.style.display = 'block';
                  }
                  if (overlay) {
                    overlay.style.display = 'block';
                  }
                  
                  return false;
                }
              }
            } catch (e) {
              console.log('Error parsing variant data:', e);
            }
          }
        }
      });
    }
  });
  
  // ==== Product Accordions + Metafields ====
  // Handle dynamic metafield updates for product variants
  document.addEventListener('DOMContentLoaded', function() {
    const variantPicker = document.querySelector('[data-variant-picker]');
    const recyclingNotesDisplay = document.querySelector('#recycling-notes-text');
    const neckFinishDisplay = document.querySelector('#neck-finish-text');
    const neckSizeDisplay = document.querySelector('#neck-size-text');
    const capacityFillVolumeDisplay = document.querySelector('#capacity-fill-volume-text');
    const brimfulCapacityDisplay = document.querySelector('#brimful-capacity-text');
    const heightDisplay = document.querySelector('#height-text');
    const widthDisplay = document.querySelector('#width-text');
    const labelHeightDisplay = document.querySelector('#label-height-text');
    const materialDisplay = document.querySelector('#material-text');
    const productColourDisplay = document.querySelector('#product-colour-text');
    const closureColourDisplay = document.querySelector('#closure-colour-text');
    const closureTypeDisplay = document.querySelector('#closure-type-text');
    const closureSizeDisplay = document.querySelector('#closure-size-text');
    const dipTubeLengthDisplay = document.querySelector('#dip-tube-length-text');
    // Note: arrival date elements are recreated when price section updates, so we'll query them fresh each time
    const metafieldsDataScript = document.querySelector('#variant-metafields-data');
    

    
    // Hide all metafield text containers by default and set up for sliding
    const textContainers = document.querySelectorAll('.variant-metafield-display__text-container');
    textContainers.forEach(function(container) {
      container.style.display = 'none';
      container.style.overflow = 'hidden';
      container.style.transition = 'max-height 0.1s ease-out, opacity 0.1s ease-out';
      container.style.maxHeight = '0px';
      container.style.opacity = '0';
      container.style.padding = '0'; // Initialize with no padding
    });

    
    // Add click handlers for collapsible titles
    const metafieldTitles = document.querySelectorAll('.variant-metafield-display__title');
    metafieldTitles.forEach(function(title) {
      title.addEventListener('click', function() {
        // Get the text container within this collapsible section
        const parentBlock = this.closest('.variant-metafield-display');
        const textContainer = parentBlock.querySelector('.variant-metafield-display__text-container');
        
        if (textContainer) {
          // Check if the container is currently visible
          const isVisible = textContainer.style.maxHeight !== '0px' && textContainer.style.maxHeight !== '';
          
          if (!isVisible) {
            // Slide open the container
            textContainer.style.display = 'block';
            textContainer.style.padding = '15px 0 15px'; // Add padding when opening
            // Force a reflow to ensure display: block is applied
            textContainer.offsetHeight;
            // Use a minimum height to ensure smooth animation even for small content
            const contentHeight = Math.max(textContainer.scrollHeight, 20);
            textContainer.style.maxHeight = contentHeight + 'px';
            textContainer.style.opacity = '1';
            
            // Add active class to title for styling
            this.classList.add('active');
            
            // Rotate the first SVG in data-collapsible-icon by 270 degrees
            const collapsibleIcon = this.querySelector('[data-collapsible-icon]');
            if (collapsibleIcon) {
              const firstSvg = collapsibleIcon.querySelector('svg:first-child');
              if (firstSvg) {
                firstSvg.style.transform = 'rotate(270deg)';
                firstSvg.style.transition = 'transform 0.3s ease';
              }
            }
          } else {
            // Slide closed the container
            textContainer.style.maxHeight = '0px';
            textContainer.style.opacity = '0';
            textContainer.style.padding = '0'; // Remove padding when closing
            
            // Remove active class from title
            this.classList.remove('active');
            
            // Reset the first SVG rotation
            const collapsibleIcon = this.querySelector('[data-collapsible-icon]');
            if (collapsibleIcon) {
              const firstSvg = collapsibleIcon.querySelector('svg:first-child');
              if (firstSvg) {
                firstSvg.style.transform = 'rotate(0deg)';
                firstSvg.style.transition = 'transform 0.3s ease';
              }
            }
            
            // Hide the container after animation completes
            setTimeout(function() {
              if (textContainer.style.maxHeight === '0px') {
                textContainer.style.display = 'none';
              }
            }, 100);
          }
        }
      });
      
      // Add cursor pointer to indicate clickable
      title.style.cursor = 'pointer';
    });
    
    if (variantPicker && metafieldsDataScript) {

      
      // Parse the metafield data from the JSON script
      let variantMetafields;
      try {
        variantMetafields = JSON.parse(metafieldsDataScript.textContent);
        console.log('Variant metafields data loaded:', variantMetafields);
       
        console.log('All variant IDs:', Object.keys(variantMetafields.neckSize || {}));
      } catch (error) {
        console.error('Error parsing metafields data:', error);
        return;
      }
      
      // Function to close all variant-metafield-display accordions
      function closeAllAccordions() {
        const accordionTitles = document.querySelectorAll('.variant-metafield-display__title');
        accordionTitles.forEach(title => {
          const parentBlock = title.closest('.variant-metafield-display');
          const textContainer = parentBlock.querySelector('.variant-metafield-display__text-container');
          
          if (textContainer) {
            // Close the accordion
            textContainer.style.maxHeight = '0px';
            textContainer.style.opacity = '0';
            textContainer.style.padding = '0'; // Remove padding when closing
            
            // Remove active class from title
            title.classList.remove('active');
            
            // Reset the SVG icon rotation
            const collapsibleIcon = title.querySelector('[data-collapsible-icon]');
            if (collapsibleIcon) {
              const firstSvg = collapsibleIcon.querySelector('svg:first-child');
              if (firstSvg) {
                firstSvg.style.transform = 'rotate(0deg)';
                firstSvg.style.transition = 'transform 0.3s ease';
              }
            }
          }
        });
      }
      
      // Function to update metafield displays
      function updateMetafieldDisplays(variantId) {
        // Close all accordions when variant changes
        closeAllAccordions();
        
        // Update recycling notes
        if (recyclingNotesDisplay) {
          const recyclingNotesValue = variantMetafields.recyclingNotes[variantId];
          
          if (recyclingNotesValue && recyclingNotesValue !== 'null' && recyclingNotesValue !== '' && recyclingNotesValue !== null) {
            recyclingNotesDisplay.textContent = recyclingNotesValue;
            recyclingNotesDisplay.style.display = 'block';
          } else {
            recyclingNotesDisplay.textContent = '';
            recyclingNotesDisplay.style.display = 'none';
          }
        }
        
        // Update neck finish
        if (neckFinishDisplay) {
          const neckFinishValue = variantMetafields.neckFinish[variantId];
          
          if (neckFinishValue && neckFinishValue !== 'null' && neckFinishValue !== '' && neckFinishValue !== null) {
            neckFinishDisplay.textContent = 'Neck Finish: ' + neckFinishValue;
            neckFinishDisplay.style.display = 'block';
          } else {
            neckFinishDisplay.textContent = '';
            neckFinishDisplay.style.display = 'none';
          }
        }
        
        // Update neck size
        if (neckSizeDisplay) {
          const neckSizeValue = variantMetafields.neckSize[variantId];
          
          if (neckSizeValue && neckSizeValue !== 'null' && neckSizeValue !== '' && neckSizeValue !== null) {
            neckSizeDisplay.textContent = 'Neck Size: ' + neckSizeValue;
            neckSizeDisplay.style.display = 'block';
          } else {
            neckSizeDisplay.textContent = '';
            neckSizeDisplay.style.display = 'none';
          }
        }
        
        // Check if both neck finish and neck size are blank and hide the entire block if so
        if (neckFinishDisplay) {
          const neckFinishBlock = neckFinishDisplay.closest('.variant-metafield-display');
          if (neckFinishBlock) {
            const neckFinishValue = variantMetafields.neckFinish[variantId];
            const neckSizeValue = variantMetafields.neckSize[variantId];
            const hasNeckFinish = neckFinishValue && neckFinishValue !== 'null' && neckFinishValue !== '' && neckFinishValue !== null;
            const hasNeckSize = neckSizeValue && neckSizeValue !== 'null' && neckSizeValue !== '' && neckSizeValue !== null;
            
            if (!hasNeckFinish && !hasNeckSize) {
              neckFinishBlock.style.display = 'none';
            } else {
              neckFinishBlock.style.display = 'block';
            }
          }
        }
        
        // Check if recycling notes container should be hidden
        if (recyclingNotesDisplay) {
          const recyclingNotesContainer = recyclingNotesDisplay.closest('.variant-metafield-display__text-container');
          const recyclingNotesBlock = recyclingNotesDisplay.closest('.variant-metafield-display');
          if (recyclingNotesContainer && recyclingNotesBlock) {
            const recyclingNotesValue = variantMetafields.recyclingNotes[variantId];
            const hasRecyclingNotes = recyclingNotesValue && recyclingNotesValue !== 'null' && recyclingNotesValue !== '' && recyclingNotesValue !== null;
            
            if (!hasRecyclingNotes) {
              recyclingNotesBlock.style.display = 'none';
            } else {
              recyclingNotesBlock.style.display = 'block';
            }
          }
        }
        
        // Update capacity fill volume
        if (capacityFillVolumeDisplay) {
          const capacityFillVolumeValue = variantMetafields.capacityFillVolume[variantId];
          
          if (capacityFillVolumeValue && capacityFillVolumeValue !== 'null' && capacityFillVolumeValue !== '' && capacityFillVolumeValue !== null) {
            capacityFillVolumeDisplay.textContent = 'Fill Volume (approx): ' + capacityFillVolumeValue;
            capacityFillVolumeDisplay.style.display = 'block';
          } else {
            capacityFillVolumeDisplay.textContent = '';
            capacityFillVolumeDisplay.style.display = 'none';
          }
        }
        
        // Update brimful capacity
        if (brimfulCapacityDisplay) {
          const brimfulCapacityValue = variantMetafields.brimfulCapacity[variantId];
          
          if (brimfulCapacityValue && brimfulCapacityValue !== 'null' && brimfulCapacityValue !== '' && brimfulCapacityValue !== null) {
            // Ensure "mL" is appended if not already present
            let displayValue = brimfulCapacityValue.toString().trim();
            // Check if value already contains mL, ml, L, or l (case insensitive)
            const hasUnit = /\s*(ml|mL|milliliter|millilitre|L|l|liter|litre)\s*$/i.test(displayValue);
            if (!hasUnit) {
              displayValue = displayValue + 'mL';
            }
            brimfulCapacityDisplay.textContent = 'Brimful Capacity: ' + displayValue;
            brimfulCapacityDisplay.style.display = 'block';
          } else {
            brimfulCapacityDisplay.textContent = '';
            brimfulCapacityDisplay.style.display = 'none';
          }
        }
        
        // Check if both capacity fill volume and brimful capacity are blank and hide the entire block if so
        if (capacityFillVolumeDisplay) {
          const capacityBlock = capacityFillVolumeDisplay.closest('.variant-metafield-display');
          if (capacityBlock) {
            const capacityFillVolumeValue = variantMetafields.capacityFillVolume[variantId];
            const brimfulCapacityValue = variantMetafields.brimfulCapacity[variantId];
            const hasCapacityFillVolume = capacityFillVolumeValue && capacityFillVolumeValue !== 'null' && capacityFillVolumeValue !== '' && capacityFillVolumeValue !== null;
            const hasBrimfulCapacity = brimfulCapacityValue && brimfulCapacityValue !== 'null' && brimfulCapacityValue !== '' && brimfulCapacityValue !== null;
            
            if (!hasCapacityFillVolume && !hasBrimfulCapacity) {
              capacityBlock.style.display = 'none';
            } else {
              capacityBlock.style.display = 'block';
            }
          }
        }
        
        // Update height
        if (heightDisplay) {
          const heightValue = variantMetafields.height[variantId];
          
          if (heightValue && heightValue !== 'null' && heightValue !== '' && heightValue !== null) {
            heightDisplay.textContent = 'Height: ' + heightValue;
            heightDisplay.style.display = 'block';
          } else {
            heightDisplay.textContent = '';
            heightDisplay.style.display = 'none';
          }
        }
        
        // Update diameter (formerly width)
        if (widthDisplay) {
          const diameterValue = variantMetafields.diameter[variantId];
          
          if (diameterValue && diameterValue !== 'null' && diameterValue !== '' && diameterValue !== null) {
            widthDisplay.textContent = 'Diameter: ' + diameterValue;
            widthDisplay.style.display = 'block';
          } else {
            widthDisplay.textContent = '';
            widthDisplay.style.display = 'none';
          }
        }
        
        // Update label height
        if (labelHeightDisplay) {
          const labelHeightValue = variantMetafields.labelHeight[variantId];
          
          if (labelHeightValue && labelHeightValue !== 'null' && labelHeightValue !== '' && labelHeightValue !== null) {
            labelHeightDisplay.textContent = 'Label Height: ' + labelHeightValue;
            labelHeightDisplay.style.display = 'block';
          } else {
            labelHeightDisplay.textContent = '';
            labelHeightDisplay.style.display = 'none';
          }
        }
        
        // Check if all dimension values are blank and hide the entire block if so
        if (heightDisplay) {
          const dimensionsBlock = heightDisplay.closest('.variant-metafield-display');
          if (dimensionsBlock) {
            const heightValue = variantMetafields.height[variantId];
            const diameterValue = variantMetafields.diameter[variantId];
            const labelHeightValue = variantMetafields.labelHeight[variantId];
            const hasHeight = heightValue && heightValue !== 'null' && heightValue !== '' && heightValue !== null;
            const hasDiameter = diameterValue && diameterValue !== 'null' && diameterValue !== '' && diameterValue !== null;
            const hasLabelHeight = labelHeightValue && labelHeightValue !== 'null' && labelHeightValue !== '' && labelHeightValue !== null;
            
            if (!hasHeight && !hasDiameter && !hasLabelHeight) {
              dimensionsBlock.style.display = 'none';
            } else {
              dimensionsBlock.style.display = 'block';
            }
          }
        }
        
        // Update material
        if (materialDisplay) {
          const materialValue = variantMetafields.material[variantId];
          
          if (materialValue && materialValue !== 'null' && materialValue !== '' && materialValue !== null) {
            materialDisplay.textContent = 'Material: ' + materialValue;
            materialDisplay.style.display = 'block';
          } else {
            materialDisplay.textContent = '';
            materialDisplay.style.display = 'none';
          }
        }
        
        // Update product colour
        if (productColourDisplay) {
          const productColourValue = variantMetafields.productColour[variantId];
          
          if (productColourValue && productColourValue !== 'null' && productColourValue !== '' && productColourValue !== null) {
            productColourDisplay.textContent = 'Colour: ' + productColourValue;
            productColourDisplay.style.display = 'block';
          } else {
            productColourDisplay.textContent = '';
            productColourDisplay.style.display = 'none';
          }
        }
        
        // Update closure colour
        if (closureColourDisplay) {
          const closureColourValue = variantMetafields.closureColour[variantId];
          
          if (closureColourValue && closureColourValue !== 'null' && closureColourValue !== '' && closureColourValue !== null) {
            closureColourDisplay.textContent = 'Closure Colour: ' + closureColourValue;
            closureColourDisplay.style.display = 'block';
          } else {
            closureColourDisplay.textContent = '';
            closureColourDisplay.style.display = 'none';
          }
        }
        
        // Check if all material and colour values are blank and hide the entire block if so
        if (materialDisplay) {
          const materialColourBlock = materialDisplay.closest('.variant-metafield-display');
          if (materialColourBlock) {
            const materialValue = variantMetafields.material[variantId];
            const productColourValue = variantMetafields.productColour[variantId];
            const hasMaterial = materialValue && materialValue !== 'null' && materialValue !== '' && materialValue !== null;
            const hasProductColour = productColourValue && productColourValue !== 'null' && productColourValue !== '' && productColourValue !== null;
            
            if (!hasMaterial && !hasProductColour) {
              materialColourBlock.style.display = 'none';
            } else {
              materialColourBlock.style.display = 'block';
            }
          }
        }
        
        // Update closure type
        if (closureTypeDisplay) {
          const closureTypeValue = variantMetafields.closureType[variantId];
          
          if (closureTypeValue && closureTypeValue !== 'null' && closureTypeValue !== '' && closureTypeValue !== null) {
            closureTypeDisplay.textContent = 'Closure Type: ' + closureTypeValue;
            closureTypeDisplay.style.display = 'block';
          } else {
            closureTypeDisplay.textContent = '';
            closureTypeDisplay.style.display = 'none';
          }
        }
        
        // Update closure size
        if (closureSizeDisplay) {
          const closureSizeValue = variantMetafields.closureSize[variantId];
          
          if (closureSizeValue && closureSizeValue !== 'null' && closureSizeValue !== '' && closureSizeValue !== null) {
            closureSizeDisplay.textContent = 'Closure Size: ' + closureSizeValue;
            closureSizeDisplay.style.display = 'block';
          } else {
            closureSizeDisplay.textContent = '';
            closureSizeDisplay.style.display = 'none';
          }
        }
        
        // Update dip tube length
        if (dipTubeLengthDisplay) {
          const dipTubeLengthValue = variantMetafields.dipTubeLength[variantId];
          
          if (dipTubeLengthValue && dipTubeLengthValue !== 'null' && dipTubeLengthValue !== '' && dipTubeLengthValue !== null) {
            dipTubeLengthDisplay.textContent = 'Dip Tube Length: ' + dipTubeLengthValue;
            dipTubeLengthDisplay.style.display = 'block';
          } else {
            dipTubeLengthDisplay.textContent = '';
            dipTubeLengthDisplay.style.display = 'none';
          }
        }
        
        // Check if all closure values are blank and hide the entire block if so
        if (closureTypeDisplay) {
          const closureDetailsBlock = closureTypeDisplay.closest('.variant-metafield-display');
          if (closureDetailsBlock) {
            const closureTypeValue = variantMetafields.closureType[variantId];
            const closureSizeValue = variantMetafields.closureSize[variantId];
            const closureColourValue = variantMetafields.closureColour[variantId];
            const dipTubeLengthValue = variantMetafields.dipTubeLength[variantId];
            const hasClosureType = closureTypeValue && closureTypeValue !== 'null' && closureTypeValue !== '' && closureTypeValue !== null;
            const hasClosureSize = closureSizeValue && closureSizeValue !== 'null' && closureSizeValue !== '' && closureSizeValue !== null;
            const hasClosureColour = closureColourValue && closureColourValue !== 'null' && closureColourValue !== '' && closureColourValue !== null;
            const hasDipTubeLength = dipTubeLengthValue && dipTubeLengthValue !== 'null' && dipTubeLengthValue !== '' && dipTubeLengthValue !== null;
            
            if (!hasClosureType && !hasClosureSize && !hasClosureColour && !hasDipTubeLength) {
              closureDetailsBlock.style.display = 'none';
            } else {
              closureDetailsBlock.style.display = 'block';
            }
          }
        }
        
        // Update arrival date (only show when product is out of stock)
        // Query elements fresh each time since they get recreated when price section updates
        const arrivalDateDisplay = document.querySelector('#arrival-date-display');
        const arrivalDateText = document.querySelector('#arrival-date-text');
        
        if (arrivalDateDisplay && arrivalDateText) {
          const arrivalDateValue = variantMetafields.arrivalDate[variantId];
          
          // Check if the current variant is out of stock
          const form = document.querySelector('form[data-type="add-to-cart-form"]');
          let isOutOfStock = false;
          if (form) {
            const variantInput = form.querySelector('input[name="id"]');
            if (variantInput && variantInput.value) {
              // Check if the variant is available by looking at the form or other indicators
              const addToCartButton = form.querySelector('[type="submit"]');
              if (addToCartButton && addToCartButton.hasAttribute('disabled')) {
                isOutOfStock = true;
              }
              // Also check for stock message
              const stockMessage = document.querySelector('.stock-message');
              if (stockMessage && stockMessage.style.display !== 'none') {
                isOutOfStock = true;
              }
            }
          }
          
          if (isOutOfStock && arrivalDateValue && arrivalDateValue !== 'null' && arrivalDateValue !== '' && arrivalDateValue !== null) {
            // Format the date string to be more readable
            let dateString = arrivalDateValue;
            
            // Convert YYYY-MM-DD format to DD/MM/YYYY format
            if (typeof arrivalDateValue === 'string' && arrivalDateValue.match(/^\d{4}-\d{2}-\d{2}$/)) {
              const date = new Date(arrivalDateValue);
              if (!isNaN(date.getTime())) {
                const day = String(date.getDate()).padStart(2, '0');
                const month = String(date.getMonth() + 1).padStart(2, '0');
                const year = date.getFullYear();
                dateString = `${day}/${month}/${year}`;
              }
            }
            
            arrivalDateText.innerHTML = '<strong>Expected Arrival Date: </strong>' + dateString;
            arrivalDateDisplay.style.display = 'block';
          } else {
            arrivalDateText.textContent = '';
            arrivalDateDisplay.style.display = 'none';
          }
        }

        syncRequestQuotePopupFields();
      }
      
      // Listen for the theme's variant change events
      document.addEventListener('variant:change', function(event) {
        if (event.detail && event.detail.variant) {
          updateMetafieldDisplays(event.detail.variant.id);
        }
      });
      
                // Listen for changes on all radio button inputs within the variant picker
      variantPicker.addEventListener('change', function(e) {
        // Get the current variant ID from the form
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput && variantInput.value) {
            updateMetafieldDisplays(variantInput.value);
          }
        }
      });
    
          // Listen for clicks on variant picker option buttons
      const variantOptionButtons = document.querySelectorAll('.variant-picker__option-button');
      variantOptionButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          // Wait a moment for the form to update, then get the variant ID
          setTimeout(function() {
            const form = document.querySelector('form[data-type="add-to-cart-form"]');
            if (form) {
              const variantInput = form.querySelector('input[name="id"]');
              if (variantInput && variantInput.value) {
                updateMetafieldDisplays(variantInput.value);
              }
            }
          }, 100);
        });
      });
      
      // Also listen for any input changes (covers all variant selection methods)
      variantPicker.addEventListener('input', function(e) {
        // Get the current variant ID from the form
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput && variantInput.value) {
            updateMetafieldDisplays(variantInput.value);
          }
        }
      });
      
      // Initialize with current variant
      const form = document.querySelector('form[data-type="add-to-cart-form"]');
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput && variantInput.value) {
          updateMetafieldDisplays(variantInput.value);
        } else {
          // Try to get variant ID from URL
          const urlParams = new URLSearchParams(window.location.search);
          const variantIdFromUrl = urlParams.get('variant');
          if (variantIdFromUrl) {
            updateMetafieldDisplays(variantIdFromUrl);
          } else {
            // Try to get the first available variant from the metafields data
            if (variantMetafields && variantMetafields.recyclingNotes) {
              const firstVariantId = Object.keys(variantMetafields.recyclingNotes)[0];
              if (firstVariantId) {
                updateMetafieldDisplays(firstVariantId);
              }
            }
          }
        }
      }
      
      // Watch for changes to the variant input using MutationObserver
      if (form) {
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
                updateMetafieldDisplays(variantInput.value);
              }
            });
          });
          
          observer.observe(variantInput, {
            attributes: true,
            attributeFilter: ['value']
          });
          

        }
      }
      
      // Also set up a MutationObserver to watch for new variant option buttons being added
      const variantPickerObserver = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList') {
            const newButtons = document.querySelectorAll('.variant-picker__option-button:not([data-metafield-listener-added])');
            newButtons.forEach(function(button) {
              button.setAttribute('data-metafield-listener-added', 'true');
              button.addEventListener('click', function() {
                setTimeout(function() {
                  const form = document.querySelector('form[data-type="add-to-cart-form"]');
                  if (form) {
                    const variantInput = form.querySelector('input[name="id"]');
                    if (variantInput && variantInput.value) {
                      updateMetafieldDisplays(variantInput.value);
                    }
                  }
                }, 100);
              });
            });
          }
        });
      });
      
      if (variantPicker) {
        variantPickerObserver.observe(variantPicker, {
          childList: true,
          subtree: true
        });
        
      }
      
      // Fallback initialization after a short delay to ensure everything is loaded
      setTimeout(function() {
        const form = document.querySelector('form[data-type="add-to-cart-form"]');
        if (form) {
          const variantInput = form.querySelector('input[name="id"]');
          if (variantInput && variantInput.value) {
            updateMetafieldDisplays(variantInput.value);
          } else {
            const urlParams = new URLSearchParams(window.location.search);
            const variantIdFromUrl = urlParams.get('variant');
            if (variantIdFromUrl) {
              updateMetafieldDisplays(variantIdFromUrl);
            }
          }
        }
      }, 500);
    }
  });

  // Auto-select "No Lid" color when "Unfitted" closure type is selected
  function setupClosureTypeAutoSelection() {
    const closureTypeInputs = document.querySelectorAll('input[name*="Closure Type"]');
    
    closureTypeInputs.forEach(input => {
      input.addEventListener('change', function() {
        if (this.value === 'Unfitted' && this.checked) {
          // Find the "No Lid" color option
          const noLidInput = document.querySelector('input[name*="Color"][value="No Lid"]');
          if (noLidInput && !noLidInput.disabled) {
            // Select the "No Lid" option
            noLidInput.checked = true;
            noLidInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
        }
      });
    });
  }

  // Initialize the auto-selection functionality
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupClosureTypeAutoSelection);
  } else {
    setupClosureTypeAutoSelection();
  }

  // ============================================
  // Pallet Closure Type Filter
  // When a UOM containing "pallet" is selected, only show first option in Closure Type dropdown
  // ============================================
  (function() {
    //console.log('🎯 [PalletFilter] Script starting...');
    
    let originalClosureOptionsHTML = '';
    let isPalletModeActive = false;
    let observer = null;

    function isPalletSelected() {
      const uomField = document.querySelector('.variant-picker__field[data-option-name="UoM"]');
      if (!uomField) {
        //console.log('🎯 [PalletFilter] UoM field not found');
        return false;
      }
      
      const checkedRadio = uomField.querySelector('input[type="radio"]:checked');
      if (checkedRadio) {
        const value = checkedRadio.value.toLowerCase();
        return value.includes('pallet');
      }
      return false;
    }

    function applyFilter() {
      const closureSelect = document.querySelector('select[name*="Closure Type"]');
      if (!closureSelect) return;

      const palletSelected = isPalletSelected();

      if (palletSelected && closureSelect.options.length > 1) {
        // Store original HTML
        if (!originalClosureOptionsHTML) {
          originalClosureOptionsHTML = closureSelect.innerHTML;
        }
        
        // Disconnect observer temporarily to prevent infinite loop
        if (observer) observer.disconnect();
        
        // IMPORTANT: do NOT rebuild via innerHTML here.
        // Rebuilding strips attributes like data-option-value-id from the first <option>,
        // which causes <variant-picker>.selectedOptionValues to omit the closure id.
        // product-info.js then sees the option-value-ids list change after every fetch
        // and dispatches a synthetic 'change' (refetchIfOptionsFiltered), which loops
        // and calls setQuantityBoundries → this.input.value = min on every iteration,
        // forcing the quantity input back to 1.
        // Instead, remove the trailing options in place so the surviving first <option>
        // keeps its data-option-value-id and other attributes intact.
        while (closureSelect.options.length > 1) {
          closureSelect.remove(1);
        }
        const firstOption = closureSelect.options[0];
        if (firstOption) {
          firstOption.selected = true;
          firstOption.disabled = false;
          firstOption.removeAttribute('disabled');
          closureSelect.value = firstOption.value;
        }
        isPalletModeActive = true;
        //console.log('🎯 [PalletFilter] PALLET MODE - showing only:', firstOption && firstOption.value);
        
        // Reconnect observer
        setupObserver();
      } else if (!palletSelected && isPalletModeActive && originalClosureOptionsHTML) {
        if (observer) observer.disconnect();
        
        closureSelect.innerHTML = originalClosureOptionsHTML;
        closureSelect.selectedIndex = 0;
        isPalletModeActive = false;
        //console.log('🎯 [PalletFilter] NORMAL MODE - restored all options');
        
        setupObserver();
      }
    }

    function setupObserver() {
      const closureField = document.querySelector('.variant-picker__field[data-option-name="Closure Type"]');
      if (!closureField) return;
      
      if (observer) observer.disconnect();
      
      observer = new MutationObserver(() => {
        if (isPalletSelected()) {
          const closureSelect = document.querySelector('select[name*="Closure Type"]');
          if (closureSelect && closureSelect.options.length > 1) {
            //console.log('🎯 [PalletFilter] Observer detected rebuild, reapplying...');
            applyFilter();
          }
        }
      });
      
      observer.observe(closureField, { childList: true, subtree: true, characterData: true });
    }

    // When user changes UoM to a Pallet option, force the Closure Type dropdown
    // to "Unfitted (No Closure)" BEFORE <variant-picker> reads selectedOptionValues
    // for its fetch. Pallet variants only exist with the Unfitted closure, so leaving
    // e.g. "Black Fast Drip" selected (carried over from a Tray/Carton selection)
    // would send Pallet + BlackFastDrip → server can't resolve a variant → page
    // shows "Unavailable".
    //
    // Delegated on `document` (instead of on the UoM field directly) because
    // product-info.js swaps the entire <variant-picker> DOM after every variant
    // change via updateOptionValues() → HTMLUpdateUtility.viewTransition. A listener
    // bound to a specific uomField element gets discarded with the swap.
    //
    // Registered in the CAPTURE phase so this runs BEFORE <variant-picker>'s own
    // bubble-phase change handler reads selectedOptionValues.
    document.addEventListener('change', (event) => {
      const target = event.target;
      if (!target || target.tagName !== 'INPUT' || target.type !== 'radio') return;
      const uomField = target.closest('.variant-picker__field[data-option-name="UoM"]');
      if (!uomField) return;
      const value = (target.value || '').toLowerCase();
      if (!value.includes('pallet')) return;

      const closureSelect = document.querySelector('select[name*="Closure Type"]');
      if (closureSelect && closureSelect.options.length > 0) {
        closureSelect.selectedIndex = 0;
        closureSelect.value = closureSelect.options[0].value;
      }
    }, true);

    function init() {
      //console.log('🎯 [PalletFilter] Initializing...');
      
      // Setup click listener on UoM field
      const uomField = document.querySelector('.variant-picker__field[data-option-name="UoM"]');
      if (uomField) {
        //console.log('🎯 [PalletFilter] UoM field found, adding listeners');

        uomField.addEventListener('click', () => {
          //console.log('🎯 [PalletFilter] UoM clicked');
          setTimeout(applyFilter, 10);
          setTimeout(applyFilter, 50);
          setTimeout(applyFilter, 100);
          setTimeout(applyFilter, 200);
          setTimeout(applyFilter, 500);
          setTimeout(applyFilter, 1000);
        });
      }
      
      // Setup observer
      setupObserver();
      
      // Continuous polling as backup
      setInterval(() => {
        if (isPalletSelected()) {
          const closureSelect = document.querySelector('select[name*="Closure Type"]');
          if (closureSelect && closureSelect.options.length > 1) {
            applyFilter();
          }
        }
      }, 50);
      
      // Initial runs
      applyFilter();
      setTimeout(applyFilter, 100);
      setTimeout(applyFilter, 500);
      setTimeout(applyFilter, 1000);
      setTimeout(applyFilter, 2000);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  // ============================================
  // Quantity reset behavior across variant changes
  // ============================================
  // Intentionally not patching QuantityInput.setQuantityBoundries(). The theme's
  // default behavior is to reset the quantity input back to its minimum on every
  // variant change (Each / Carton / Bulk Pallet / Pallet Cartons). With the
  // Closure-Type filter loop fix above, this reset now happens exactly once per
  // variant change for ALL UoMs, so the behavior is consistent and predictable:
  // every UoM swap resets the qty to 1, and the customer can then increment it.
  // Do NOT add value-preservation logic here — it makes Pallet feel different
  // from the other variants.